export default __webpack_public_path__ + "static/media/Logo_arc_system_works.bb67e0c6.png";